export const WORKSPACE_COLOR_COUNT = 8;

// Cycles a stable color class by team id so a given workspace renders the same
// color everywhere it appears (picker dots, table chips, etc).
export const getWorkspaceColorClass = (teamId: number): string =>
  `workspace-color-${teamId % WORKSPACE_COLOR_COUNT}`;
